
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/corporate",
      function () {
        return require("private-next-pages/learn/corporate/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/corporate"])
      });
    }
  